export default "__VITE_ASSET__6kntUM0v__"